export default "__VITE_ASSET__CHkcJEkd__"